import script from "./environment-card.vue?vue&type=script&setup=true&lang=js"
export * from "./environment-card.vue?vue&type=script&setup=true&lang=js"

import "./environment-card.vue?vue&type=style&index=0&id=4b87fac8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b87fac8"]])

export default __exports__